/**
 * @description Formats a whole-week lead time for display. Lead times are stored
 * in weeks, so there is nothing to convert — only the singular to get right.
 */
export function formatLeadTimeWeeks(weeks: number) {
  if (weeks === 1) {
    return `${weeks} Week`;
  }

  return `${weeks} Weeks`;
}
